module.exports = __webpack_public_path__ + "img/controlbuttons.bc48799e.png";